import { useEffect, useState } from 'react';

import { useFormContext } from 'react-hook-form';

const useDisabledButtonWithDebounce = () => {
  const [isDisabled, setIsDisabled] = useState(true);
  const methods = useFormContext();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (!methods.formState.isValid) {
      setIsDisabled(true);
    } else {
      timer = setTimeout(() => {
        if (methods.formState.isValid) {
          setIsDisabled(false);
        }
      }, 400);
    }

    return () => clearTimeout(timer);
  }, [methods.formState.isValid]);

  return {
    isDisabled,
  };
};

export default useDisabledButtonWithDebounce;
